import { createAction } from '@ngrx/store';

export const CAMPAIGN_HEADER_CREATE_ENTITY_CLICKED = createAction(
  '[CampaignHeader] Create Entity Clicked'
);

